export default "__VITE_ASSET__B56xq7mr__"